import { render } from "./RecentLeadsTable.vue?vue&type=template&id=ff06c3d0&scoped=true"
import script from "./RecentLeadsTable.vue?vue&type=script&lang=js"
export * from "./RecentLeadsTable.vue?vue&type=script&lang=js"

import "./RecentLeadsTable.vue?vue&type=style&index=0&id=ff06c3d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff06c3d0"]])

export default __exports__